import React, { useState } from "react";
import { Col } from "reactstrap";
import { useNavigate, useSearchParams } from "react-router-dom";

// Components
import AuthContainer from "./components/AuthContainer";
import ForgotPasswordForm from "./forgot-password/ForgotPasswordForm";
import ForgotPasswordOtp from "./forgot-password/ForgotPasswordOtp";
import ForgotPasswordReset from "./forgot-password/ForgotPasswordReset";
import ForgotPasswordResult from "./forgot-password/ForgotPasswordResult";

// Steps
const STEPS = {
  FORM: "form",
  OTP: "otp",
  RESET: "reset",
  RESULT: "result",
};

const ForgotPassword = () => {
  // Set page title
  document.title = "ลืมรหัสผ่าน | " + process.env.REACT_APP_CMS_TITLE;

  const [step, setStep] = useState(STEPS.FORM);
  const [userData, setUserData] = useState(null);

  const handleFormSuccess = (data) => {
    console.log(data);
    setUserData(data);
    setStep(STEPS.OTP);
  };

  const handleOtpSuccess = () => {
    setStep(STEPS.RESET);
  };

  const handleResetSuccess = () => {
    setStep(STEPS.RESULT);
  };

  const renderStep = () => {
    switch (step) {
      case STEPS.OTP:
        return (
          <ForgotPasswordOtp userData={userData} onSuccess={handleOtpSuccess} />
        );
      case STEPS.RESET:
        return (
          <ForgotPasswordReset
            userData={userData}
            onSuccess={handleResetSuccess}
          />
        );
      case STEPS.RESULT:
        return <ForgotPasswordResult userData={userData} />;
      case STEPS.FORM:
      default:
        return <ForgotPasswordForm onSuccess={handleFormSuccess} />;
    }
  };

  return (
    <React.Fragment>
      <AuthContainer>
        <div className="w-full">{renderStep()}</div>
      </AuthContainer>
    </React.Fragment>
  );
};

export default ForgotPassword;
